import { Modal } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import configurationAPI from "../../apis/configuration/configurationAPI";
import { useContext, useState } from "react";
import Configurationcontext from "../../Context/ConfigrationContext/Configurationcontext";
import { fetchMasterOnClientLocation } from "../../services/managerService";

function CopyFeedbackCategoriesModal({
  onHide,
  show,
  categoryKey,
  categoryHeader,
  onApplyCategories,
}) {
  const configurationProvider = useContext(Configurationcontext);
  const [locations, setLocations] = useState([]);
  const [categories, setCategories] = useState([]);

  const {
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      sourceClient: null,
      sourceLocation: null,
    },
  });

  const sourceClient = watch("sourceClient");
  const sourceLocation = watch("sourceLocation");


  const renderClientName = () => {
    return configurationProvider?.client?.map((c) => ({
      label: c.client_name,
      value: c.id,
    }));
  };

  const renderLocationOptions = () => {
    return locations.length> 0 && locations.map((location) => ({
      label: location.name,
      value: location.id,
    }));
  };

  const handleClientChange = async (selectedClient, onChange) => {
    onChange(selectedClient);
    if (selectedClient) {
      const response = await fetchMasterOnClientLocation(selectedClient.value, 0);
      setLocations(response?.locations || []);
    } else {
      setLocations([]);
    }
  };

  const onSubmit = async (data) => {
    try {

      const response = await configurationAPI.getFeedbackCategoriesCopy({
        clientId: data.sourceClient.value,
        locationId: data.sourceLocation.value,
        categoryKey,
      });

      if (response?.success) {
        if (response.data.categories.length === 0) {
          window.toastr.info("No categories found for this location.");
        } else {
          setCategories(response.data.categories);
          window.toastr.success("Categories fetched successfully");
        }
      } else {
        window.toastr.error(response?.message || "Failed to fetch categories");
      }
    } catch (error) {
      window.toastr.error("Something went wrong");
    }
  };

  const handleCopy = () => {
    onApplyCategories(categoryKey, categories);
    onHide();
  }

  return (
    <Modal onHide={onHide} centered show={show}>
      <Modal.Header closeButton>
        <Modal.Title>Copy Categories for {categoryHeader}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="form mx-5 mx-xl-7 my-7"
        >
          <div className="row justify-content-center">
            <div className="fv-row mb-7 col-lg-12">
              <label className="fs-6 fw-semibold mb-2 required">
                Source Client
              </label>
              <Controller
                name="sourceClient"
                control={control}
                rules={{ required: true }}
                render={({ field: { onChange, value } }) => (
                  <Select
                    options={renderClientName()}
                    value={value}
                    onChange={(val) => handleClientChange(val, onChange)}
                    placeholder="Select source client"
                  />
                )}
              />
              {errors.sourceClient && (
                <p className="text-danger">Source client is required</p>
              )}
            </div>

            <div className="fv-row mb-7 col-lg-12">
              <label className="fs-6 fw-semibold mb-2 required">
                Source Location
              </label>
              <Controller
                name="sourceLocation"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={renderLocationOptions()}
                    placeholder="Select source location"
                    isDisabled={locations.length === 0}
                  />
                )}
              />
              {errors.sourceLocation && (
                <p className="text-danger">Source location is required</p>
              )}
            </div>
          </div>

          <div className="d-flex pt-3 flex-left justify-content-center gap-3">
            <button type="submit" className="btn btn-primary" disabled= {!sourceClient || !sourceLocation}>
              Get Categories
            </button>
          </div>
        </form>
        { categories && categories.length > 0 && (
          <div className="mx-5 mx-xl-7 my-5 border rounded p-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="mb-0">Preview ({categories.length} categories):</h6>
            </div>
            
            <div className="categories-list" style={{ maxHeight: '200px', overflowY: 'auto' }}>
              {categories.map((category, index) => (
                <div key={index} className="d-flex align-items-center py-2 border-bottom">
                  <span className="fw-medium">{category}</span>
                </div>
              ))}
            </div>

            <div className="d-flex justify-content-center gap-3 mt-5 pt-4 ">
              <button
                type="button"
                className="btn btn-light-primary"
                onClick={onHide}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleCopy}
              >
                Copy These Categories
              </button>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default CopyFeedbackCategoriesModal;
